import './config';
import React from 'react';
import PropTypes from 'prop-types';
import { IdleUser } from './IdleUser';

export const Widget = (props) => {
  return <IdleUser {...props} />;
};

Widget.displayName = 'utility/IdleUser';

Widget.propTypes = {
  data: PropTypes.shape({
    idleTimeout: PropTypes.number,
    timeRemaining: PropTypes.number,
  }),
  events: PropTypes.shape({
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
  }),
};

Widget.defaultProps = {
  data: {
    idleTimeout: 1200000,
    timeRemaining: 600000,
  },
  events: null,
};
